<div id="subscriptionSingleFeeEmail" style="display: none">
  <div style="padding: 0px !important; width: 400px; max-width: 400px; margin: auto !important; box-shadow: 0 0 0 0 !important; border: 0px solid #eee !important;">
      <div style="width: 400px; max-width: 400px">
          <table style="border-collapse: collapse; font-size: 12px; font-size: 9px; margin-top: 3px; line-height: normal;">
              <thead style="border: 1px solid black; text-align: center; font-weight: bold; font-size: 12px; font-size: 9px; background-color: black; color: white; border: 1px solid black;">
                  <tr style="background-color: black;">
                      <th style="width: 40px; word-break: break-word; font-size: 10px;">
                          {{setLabel("m#Label")}}
                      </th>
                      <th style="width: 40px; word-break: break-word; font-size: 10px;">
                          {{setLabel("nameLabel")}}
                      </th>
                      <th style="width: 40px; word-break: break-word; font-size: 10px;">
                          {{setLabel("typeLabel")}}
                      </th>
                      <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
                    <th style="width: 40px; font-size: 9px">{{setLabel("discountLabel")}}</th>
                      <th style="width: 40px; font-size: 9px" *ngIf="fee.taxCalculationType !== 'NO_TAX'">{{setLabel("taxLabel")}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td style="font-size: 9px; border: 1px solid black; text-align: center;">
                          {{ fee.membershipNumber }}
                      </td>
                      <td style="font-size: 9px; border: 1px solid black; text-align: center;">
                          {{ fee.memberName }}
                      </td>
                      <td style="font-size: 9px; border: 1px solid black; text-align: center;">
                          {{ fee.feeType }}
                      </td>
                      <td style="font-size: 9px; border: 1px solid black; text-align: center;">
                          {{ fee.fee }}
                      </td>
                      <td style="font-size: 9px; border: 1px solid black; text-align: center;" *ngIf="fee.taxCalculationType !== 'NO_TAX'">
                          {{ fee.tax }}
                      </td>
                      <td style="font-size: 9px; border: 1px solid black; text-align: center;">
                          {{ fee.discount }}
                      </td>
                  </tr>
                  <tr>
                      <td *ngIf="fee.taxCalculationType !== 'NO_TAX'"></td>
                      <td></td>
                      <td></td>
                      <td style="font-size: 10px; text-align: center; font-weight: bold; border-bottom: 1px solid; border-left: 1px solid;" colspan="2">
                          {{setLabel("subTotalLabel")}}
                      </td>
                      <td style="font-size: 10px; text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
                          <span>
                              {{ calculateTotalForSinglePrint(fee.fee, fee.tax, fee.discount,fee.taxCalculationType) }}
                          </span>
                      </td>
                  </tr>
                  <tr *ngIf="fee.taxCalculationType === 'INCLUDING_TAX'">
                      <td colspan="6">
                          <i style="display: block; font-size: 8px;">
                              {{fee.tax}} {{setLabel("taxIncludedFeeLabel")}}
                          </i>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</div>
<!--
<p-dialog [(visible)]="showEmailSingleReceiptPreview" class="singleReceiptsEmail" [closeOnEscape]="true" [focusOnShow]="false" [style]="{ width: '54vw', left: '10px', top: '24px' }">
    <p-header>{{setLabel("sendReceiptLabel")}}</p-header>
    <form #emailConfirmationForm1="ngForm">
        <div style="height: 60vh">
            <div class="p-g-12" style="padding-bottom: 20px">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" pTooltip="Send To" tooltipPosition="top">
                      <i class="fa fa-user" aria-hidden="true"></i>
                    </span>
                    <input autocomplete="off" [(ngModel)]="email.to" pattern="^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+,*[\W]*)+$" type="text" pInputText [title]='setLabel("toPlaceholderLabel")' name="to" required />
                </div>
            </div>
            <div class="p-g-12" style="padding-bottom: 20px">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" pTooltip="Subject" tooltipPosition="top">
                      <i class="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                    <input autocomplete="off" [(ngModel)]="email.subject" type="text" pInputText [title]='setLabel("subjectPlaceholderLabel")' name="subject" required />
                </div>
            </div>
            <div class="p-g-12 ck-editor_bodyScroll">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" pTooltip="Body" tooltipPosition="top">
                      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </span>
                    <ckeditor name="ckeditor" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" [editor]="Editor" [(ngModel)]="email.body"></ckeditor>
                </div>
            </div>
        </div>
        <p-footer>
            <div class="email-button">
                <button style="background: #e7e7e7; color: black;" (click)="closeEmailConfirmation()" class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("cancelLabel")}}
                </button>
                <button [disabled]="!emailConfirmationForm1.valid" style="background: #4caf50; color: white;" (click)="sendInvoiceEmailAsPdf()" class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("sendLabel")}}
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog> -->